import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
const defaultStyle = {
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  padding: 8,
  height: 40,
  flex: '0 0 40px',
}

const LoadingIndicator = ({style = {}}) => {
  return (
    <div style={{...defaultStyle, ...style}}>
      <CircularProgress size={24} />
    </div>
  )
}

export default LoadingIndicator
